<div mat-dialog-title>
  <div class="dialog-header">
    <div class="title">Create new Project</div>
    <div class="actions">
      <mat-icon svgIcon="close" class="action-icon" (click)="close()"></mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="create-record-content">

    <!-- Title -->
    <div class="row">
      <div class="title">Project Name</div>
      <input class="input" [(ngModel)]="name">
    </div>

  </div>
</div>

<div mat-dialog-actions class="mat-dialog-actions dialog-actions">
  <div class="button secondary" (click)="close()">Cancel</div>
  <div class="button" (click)="create()">Create</div>
</div>
